import { FormSection } from '../FormSection';
import { cn } from '@/helpers/classnames';
import { InputCheckBox } from '../Inputs/InputCheckBox';
import { FormattedMessage, useIntl } from 'react-intl';
import { SchemaType } from '@/hooks/useStudentFormSchema';
import { useFormContext } from 'react-hook-form';

interface StudentProductType {
  editMode: boolean;
}

export const StudentProductType = ({ editMode }: StudentProductType) => {
  return (
    <FormSection editMode={editMode} className="flex flex-col gap-2">
      <AddressFields field="half_product" editMode={editMode} />
    </FormSection>
  );
};

interface AddressFieldsProps {
  field: string;
  editMode: boolean;
  className?: string;
}

type StudentFormType =
  | SchemaType<'create' | 'update', 'transportation'>
  | SchemaType<'create' | 'update', 'travels'>
  | SchemaType<'create' | 'update', 'child-and-youth'>;

const AddressFields = ({ editMode, className }: AddressFieldsProps) => {
  const { setValue, watch } = useFormContext<StudentFormType>();
  const { formatMessage } = useIntl();

  const isHalfProduct = watch('half_product');

  const onChange = () => {
    setValue('half_product', !isHalfProduct, {
      shouldDirty: true,
    });
  };

  return (
    <div className={cn('flex flex-row', className)}>
      {!editMode && (
        <span className="mr-4">
          <FormattedMessage defaultMessage="Halvprodukt" />:
        </span>
      )}
      <InputCheckBox
        label={formatMessage({
          defaultMessage: 'Halv produkt (Rabatt enligt överenskommelse)',
        })}
        name="half_product"
        editMode={editMode}
        onChange={onChange}
      />
    </div>
  );
};
